import clsx from "clsx";

import { getTrackingColor } from "~/modules/dashboard/components/TimeTrackingCalendar/entryStyles.ts";
import type { TimeTrackingExtendedType } from "~/modules/timeTracking/api/timeTracking/timeTrackingTypes.ts";
import {
	getTimeTrackingBarTheme,
} from "~/modules/timeTracking/components/components/Day/components/TimeTrackingBar/getTimeTrackingBarTheme.ts";
import { formatNumberWithComma } from "~/utils/numberUtils.ts";

type Props = {
	timeTracking: TimeTrackingExtendedType;
	onClick: () => void;
};

/**
 * A closed tracking of the day list: a small card with the top stripe of the open `EntryCard`.
 * The open card then only adds its details, with no change of style, and several trackings do not read as a bullet list.
 */
export function TrackingEntryRow({ timeTracking, onClick }: Props) {
	const { theme, title } = getTimeTrackingBarTheme(timeTracking);
	const color = getTrackingColor(theme);

	return (
		<button type="button"
				className="w-full overflow-hidden rounded-lg bg-white text-left text-sm ring-1 ring-gray-200 hover:ring-gray-400"
				onClick={onClick}>
			<div className={clsx("h-1.5", color.solid)} />
			<div className="flex items-center gap-2 px-3 py-2">
				<span className={clsx("min-w-0 truncate font-semibold", theme === "projectNotBillable" ? color.text : "text-gray-800")}>{title ?? "Erfassung"}</span>
				<span className="ml-auto shrink-0 font-semibold text-gray-700">{formatNumberWithComma(timeTracking.minutes / 60, 1, false)} h</span>
			</div>
		</button>
	);
}
